const forms = {
  onRequest: "Kapag Hiniling", // translated 
  person: "tao", // translated 
  travelDate: "Petsa ng Paglalakbay", // translated 
  travelDates: "Mga Petsa ng Paglalakbay", // translated 
  cancel: "Kanselahin", // translated 
  getPrice: "Kunin ang Presyo", // translated 
};


export default forms;
